import { SupplierActivity } from '@linktivity/gds-neo';
import config from '../config';

const supplierAccountApi = new SupplierActivity.ActivityApi(config);

export default supplierAccountApi;
